import { useEffect, useState } from 'react';
import { clienteService } from '../../services/api';
import '../../styles/Clientes.css';
import { cleanCedula, formatCedula, isValidCedula } from '../../utils/cedulaFormatter';

const placeholderImg =
  'data:image/svg+xml;utf8,' +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="160" height="160"><rect width="100%" height="100%" fill="#f2f2f2"/><circle cx="80" cy="60" r="36" fill="#d9d9d9"/><rect x="40" y="110" width="80" height="30" rx="15" fill="#d9d9d9" /></svg>`
  );

function normalizeJceData(data) {
  console.log('=== normalizeJceData ENTRADA ===');
  console.log('data recibida:', data);
  console.log('tipo:', typeof data);

  if (!data || typeof data !== 'object') {
    console.log('❌ Data inválida');
    return {};
  }

  // Axios ya parseó el JSON, así que 'data' contiene directamente el objeto
  // NO buscar en data.response porque response es un código de estado (777)
  const inner = data;
  console.log('Datos a procesar:', inner);
  console.log('Claves disponibles:', Object.keys(inner));

  // Obtener nombres - usar el campo "nombres" directamente
  const nombres = inner.nombres || inner.Nombres || inner.primer_nombre || inner.first_name || '';
  console.log('Nombres extraídos:', nombres);

  // Obtener apellidos - combinar apellido1 y apellido2 si existen, o usar "apellidos"
  let apellidos = '';
  if (inner.apellido1 || inner.apellido2) {
    apellidos = `${inner.apellido1 || ''} ${inner.apellido2 || ''}`.trim();
  } else {
    apellidos = inner.apellidos || inner.Apellidos || inner.primer_apellido || inner.last_name || '';
  }
  console.log('Apellidos extraídos:', apellidos);

  // Procesar fecha de nacimiento - convertir de "15/1/1981 12:00:00 a. m." a formato ISO "YYYY-MM-DD"
  let fecha_nacimiento = '';
  if (inner.fechaNacimiento || inner.fecha_nacimiento || inner.FechaNacimiento) {
    const fechaStr = inner.fechaNacimiento || inner.fecha_nacimiento || inner.FechaNacimiento;
    console.log('Fecha original:', fechaStr);
    // Extraer la fecha en formato DD/M/YYYY o similar
    const match = fechaStr.match(/(\d{1,2})\/(\d{1,2})\/(\d{4})/);
    if (match) {
      const [_, dia, mes, anio] = match;
      // Convertir a formato ISO YYYY-MM-DD
      const diaFormatted = dia.padStart(2, '0');
      const mesFormatted = mes.padStart(2, '0');
      fecha_nacimiento = `${anio}-${mesFormatted}-${diaFormatted}`;
      console.log('Fecha convertida:', fecha_nacimiento);
    }
  }

  // Procesar estado civil - convertir "S" a "Soltero", "C" a "Casado", etc.
  let estado_civil = '';
  const estadoCivilRaw = inner.estadoCivil || inner.estado_civil || inner.EstadoCivil || inner.civil || inner.civil_state || '';
  console.log('Estado civil raw:', estadoCivilRaw);
  if (estadoCivilRaw === 'S' || estadoCivilRaw.toLowerCase() === 'soltero') {
    estado_civil = 'Soltero';
  } else if (estadoCivilRaw === 'C' || estadoCivilRaw.toLowerCase() === 'casado') {
    estado_civil = 'Casado';
  } else if (estadoCivilRaw === 'U' || estadoCivilRaw.toLowerCase() === 'unión libre') {
    estado_civil = 'Unión libre';
  } else if (estadoCivilRaw === 'D' || estadoCivilRaw.toLowerCase() === 'divorciado') {
    estado_civil = 'Divorciado';
  } else if (estadoCivilRaw === 'V' || estadoCivilRaw.toLowerCase() === 'viudo') {
    estado_civil = 'Viudo';
  } else if (estadoCivilRaw) {
    estado_civil = estadoCivilRaw;
  }
  console.log('Estado civil procesado:', estado_civil);

  // Procesar sexo - convertir "M" a "Masculino", "F" a "Femenino"
  let sexo = '';
  const sexoRaw = inner.sexo || inner.genero || inner.Sexo || inner.Genero || '';
  console.log('Sexo raw:', sexoRaw);
  if (sexoRaw === 'M' || sexoRaw.toLowerCase() === 'masculino') {
    sexo = 'Masculino';
  } else if (sexoRaw === 'F' || sexoRaw.toLowerCase() === 'femenino') {
    sexo = 'Femenino';
  } else if (sexoRaw) {
    sexo = sexoRaw;
  }
  console.log('Sexo procesado:', sexo);

  // Construir URL de la foto usando la cédula
  const cedula = inner.cedula || '';
  const foto_perfil = cedula
    ? `https://fotospadron2024.blob.core.windows.net/fotos/${cedula}.jpg`
    : inner.foto || inner.Foto || inner.foto_base64 || inner.fotoBase64 || inner.image_base64 || '';

  const direccion = inner.direccion || inner.Direccion || inner.address || inner.domicilio || '';

  const resultado = { nombres, apellidos, foto_perfil, fecha_nacimiento, estado_civil, direccion, sexo };
  console.log('Resultado final de normalizeJceData:', resultado);
  return resultado;
}

const ClienteForm = ({ mode = 'create', clienteId, onSaved }) => {
  const [lookupCedula, setLookupCedula] = useState('');
  const [lookupLoading, setLookupLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [foundClienteId, setFoundClienteId] = useState(null); // Para guardar el ID del cliente encontrado
  const [cobradores, setCobradores] = useState([]); // Lista de cobradores
  const [loadingCobradores, setLoadingCobradores] = useState(false);
  const [form, setForm] = useState({
    cedula: '',
    pasaporte: '',
    rnc: '',
    nombres: '',
    apellidos: '',
    apodo: '',
    telefono: '',
    celular: '',
    direccion: '',
    negocio: '',
    sexo: '',
    estado_civil: '',
    fecha_nacimiento: '',
    foto_perfil: '',
    foto_cedula: '',
    cobrador_id: '',  // Cobrador asignado
  });

  useEffect(() => {
    // Cargar lista de cobradores
    (async () => {
      setLoadingCobradores(true);
      try {
        const resp = await clienteService.getCobradores();
        setCobradores(resp.data?.cobradores || []);
      } catch (e) {
        console.error('Error al cargar cobradores:', e);
      } finally {
        setLoadingCobradores(false);
      }
    })();

    // Cargar cliente si estamos en modo edición
    if (mode === 'edit' && clienteId) {
      (async () => {
        try {
          const resp = await clienteService.getCliente(clienteId);
          setForm((f) => ({ ...f, ...resp.data }));
          setLookupCedula(resp.data.cedula);
        } catch (e) {
          setError(e.response?.data?.error || 'No se pudo cargar el cliente');
        }
      })();
    }
  }, [mode, clienteId]);

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const doLookup = async () => {
    setError(''); setMessage('');
    if (!lookupCedula) { setError('Ingresa una cédula'); return; }
    if (!isValidCedula(lookupCedula)) {
      setError('La cédula debe tener 11 dígitos');
      return;
    }
    setLookupLoading(true);
    try {
      const cedulaLimpia = cleanCedula(lookupCedula);

      // Si estamos en modo edición, buscar el cliente en la base de datos
      if (mode === 'edit') {
        try {
          const clientesResp = await clienteService.getClientes({ cedula: cedulaLimpia });
          if (clientesResp.data && clientesResp.data.clientes && clientesResp.data.clientes.length > 0) {
            const clienteExistente = clientesResp.data.clientes[0];
            setFoundClienteId(clienteExistente.id);
            setForm((prev) => ({ ...prev, ...clienteExistente }));
            setMessage('Cliente encontrado - puedes editar los datos');
            setLookupLoading(false);
            return;
          }
        } catch (err) {
          console.log('Cliente no existe en BD, consultando JCE...');
        }
      }

      // Consultar datos de la cédula en JCE
      try {
        const resp = await clienteService.validarCedula(cedulaLimpia);
        const norm = normalizeJceData(resp.data);

        setForm((prev) => ({ ...prev, cedula: cedulaLimpia, ...norm }));
        setMessage(mode === 'edit' ? 'Cliente no encontrado - se creará uno nuevo' : 'Datos cargados desde la cédula');
      } catch (jceError) {
        // Si falla la consulta JCE, permitir continuar manualmente
        console.warn('No se pudieron obtener datos de JCE, puedes ingresar los datos manualmente:', jceError);
        setForm((prev) => ({ ...prev, cedula: cedulaLimpia }));
        setMessage('⚠️ No se pudieron obtener datos automáticos. Puedes ingresar los datos manualmente.');
      }
    } catch (e) {
      console.error('Error lookup:', e);
      // Si hay un error general, también permitir continuar manualmente
      setForm((prev) => ({ ...prev, cedula: lookupCedula ? cleanCedula(lookupCedula) : prev.cedula }));
      setMessage('⚠️ Error al consultar cédula. Puedes ingresar los datos manualmente.');
    } finally {
      setLookupLoading(false);
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault(); setError(''); setMessage('');

    // CONFIRMACIÓN antes de guardar
    const nombreCompleto = `${form.nombres || ''} ${form.apellidos || ''}`.trim() || 'este cliente';
    
    // Construir mensaje de confirmación con todos los documentos
    let documentos = [];
    if (form.cedula || lookupCedula) documentos.push(`Cédula: ${form.cedula || lookupCedula}`);
    if (form.pasaporte) documentos.push(`Pasaporte: ${form.pasaporte}`);
    if (form.rnc) documentos.push(`RNC: ${form.rnc}`);
    
    const mensajeDocumentos = documentos.length > 0 ? documentos.join('\n') : 'Sin documentos';
    
    const accion = mode === 'edit' ? 'ACTUALIZAR' : 'CREAR NUEVO';
    
    const confirmacion = window.confirm(
      `¿${accion} CLIENTE?\n\n` +
      `Nombre: ${nombreCompleto.toUpperCase()}\n` +
      `${mensajeDocumentos}\n` +
      `Celular: ${form.celular || 'No especificado'}\n\n` +
      `¿Desea continuar?`
    );

    if (!confirmacion) {
      setMessage('❌ Guardado cancelado por el usuario');
      return;
    }

    setSaving(true);
    try {
      const payload = {
        cedula: form.cedula || lookupCedula || null,
        pasaporte: form.pasaporte || null,
        rnc: form.rnc || null,
        nombres: form.nombres,
        apellidos: form.apellidos,
        apodo: form.apodo,
        telefono: form.telefono,
        celular: form.celular,
        direccion: form.direccion,
        negocio: form.negocio,
        sexo: form.sexo,
        estado_civil: form.estado_civil,
        fecha_nacimiento: form.fecha_nacimiento,
        foto_perfil: form.foto_perfil,
        foto_cedula: form.foto_cedula,
        cobrador_id: form.cobrador_id ? parseInt(form.cobrador_id) : null,  // Asignar cobrador
      };
      console.log('Payload a enviar:', payload);
      let resp;
      const idToUse = clienteId || foundClienteId;
      if (mode === 'edit' && idToUse) {
        resp = await clienteService.updateCliente(idToUse, payload);
        setMessage(`✅ CLIENTE ACTUALIZADO EXITOSAMENTE: ${nombreCompleto.toUpperCase()}`);
      } else {
        resp = await clienteService.createCliente(payload);
        setMessage(`✅ CLIENTE CREADO EXITOSAMENTE: ${nombreCompleto.toUpperCase()}`);
      }
      
      // Mostrar alerta de éxito también
      setTimeout(() => {
        window.alert(mode === 'edit' 
          ? `✅ Cliente actualizado correctamente\n\n${nombreCompleto.toUpperCase()}`
          : `✅ Cliente creado correctamente\n\n${nombreCompleto.toUpperCase()}`
        );
      }, 100);
      
      onSaved && onSaved(resp.data?.cliente || resp.data);
    } catch (e) {
      console.error('Error al guardar:', e);
      console.error('Respuesta del error:', e.response?.data);
      setError(e.response?.data?.error || 'Error al guardar');
    } finally {
      setSaving(false);
    }
  };

  return (
    <form className="cliente-form" onSubmit={onSubmit}>
      {(error || message) && (
        <div className={`banner ${error ? 'error' : 'ok'}`}>{error || message}</div>
      )}
      <div className="panel grid">
        <div className="card left">
          <div className="card-title green">Datos Principales</div>
          <div className="foto-wrapper">
            <img src={form.foto_perfil || placeholderImg} alt="perfil" className="foto" />
          </div>
          <div className="field-group">
            <label>DNI</label>
            <div className="dni-row">
              <input
                type="text"
                placeholder="000-0000000-0"
                value={lookupCedula}
                onChange={(e) => {
                  const formatted = formatCedula(e.target.value);
                  setLookupCedula(formatted);
                }}
                onKeyPress={(e) => {
                  // Consultar automáticamente al presionar Enter
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    doLookup();
                  }
                }}
                maxLength="13"
              />
              <button type="button" className="btn lookup" onClick={doLookup} disabled={lookupLoading}>
                {lookupLoading ? 'Buscando…' : 'Ver'}
              </button>
            </div>
            <div className="dni-tipos">
              {lookupCedula && (
                <span style={{color: isValidCedula(lookupCedula) ? '#2e7d32' : '#c62828'}}>
                  {isValidCedula(lookupCedula) ? '✓ Cédula válida (11 dígitos) - Presiona Enter para consultar' : `✗ Faltan ${11 - cleanCedula(lookupCedula).length} dígitos`}
                </span>
              )}
            </div>
          </div>

          <div className="grid-2">
            <div className="field">
              <label>🛂 Pasaporte</label>
              <input 
                name="pasaporte" 
                value={form.pasaporte || ''} 
                onChange={onChange} 
                placeholder="Ej: A12345678"
                maxLength="50"
              />
            </div>
            <div className="field">
              <label>🏢 RNC</label>
              <input 
                name="rnc" 
                value={form.rnc || ''} 
                onChange={onChange} 
                placeholder="Ej: 123-45678-9"
                maxLength="20"
              />
            </div>
          </div>
          <div className="info-box" style={{margin: '0.5rem 0', padding: '0.5rem', background: '#e3f2fd', borderRadius: '4px', fontSize: '0.85rem'}}>
            ℹ️ Proporciona al menos uno: Cédula, Pasaporte o RNC
          </div>

          <div className="grid-2">
            <div className="field">
              <label>Nombre(s)</label>
              <input name="nombres" value={form.nombres} onChange={onChange} required />
            </div>
            <div className="field">
              <label>Apellidos</label>
              <input name="apellidos" value={form.apellidos} onChange={onChange} required />
            </div>
            <div className="field">
              <label>Sexo</label>
              <select name="sexo" value={form.sexo || ''} onChange={onChange}>
                <option value="">--Seleccione--</option>
                <option value="Masculino">Masculino</option>
                <option value="Femenino">Femenino</option>
              </select>
            </div>
            <div className="field">
              <label>Estado civil</label>
              <select name="estado_civil" value={form.estado_civil || ''} onChange={onChange}>
                <option value="">--Seleccione--</option>
                <option value="Soltero">Soltero</option>
                <option value="Casado">Casado</option>
                <option value="Unión libre">Unión libre</option>
                <option value="Divorciado">Divorciado</option>
                <option value="Viudo">Viudo</option>
              </select>
            </div>
            <div className="field">
              <label>Fecha de nacimiento</label>
              <input type="date" name="fecha_nacimiento" value={form.fecha_nacimiento || ''} onChange={onChange} />
            </div>
            <div className="field">
              <label>👤 Cobrador Asignado</label>
              <select
                name="cobrador_id"
                value={form.cobrador_id || ''}
                onChange={onChange}
                disabled={loadingCobradores}
              >
                <option value="">-- Sin asignar --</option>
                {cobradores.map((cobrador) => (
                  <option key={cobrador.id} value={cobrador.id}>
                    {cobrador.nombre_completo} ({cobrador.username})
                  </option>
                ))}
              </select>
              {loadingCobradores && <small style={{color: '#666'}}>Cargando cobradores...</small>}
            </div>
          </div>
        </div>

        <div className="card right">
          <div className="card-title blue">Otros Datos</div>
          <div className="field">
            <label>Dirección</label>
            <input name="direccion" value={form.direccion || ''} onChange={onChange} placeholder="Calle, número #, sector, provincia" />
          </div>
          <div className="grid-2">
            <div className="field">
              <label>Celular</label>
              <input name="celular" value={form.celular || ''} onChange={onChange} />
            </div>
            <div className="field">
              <label>Teléfono</label>
              <input name="telefono" value={form.telefono || ''} onChange={onChange} />
            </div>
          </div>
          <div className="grid-2">
            <div className="field">
              <label>Apodo</label>
              <input name="apodo" value={form.apodo || ''} onChange={onChange} />
            </div>
            <div className="field">
              <label>Negocio</label>
              <input name="negocio" value={form.negocio || ''} onChange={onChange} />
            </div>
          </div>
        </div>
      </div>

      <div className="form-actions">
        <button type="submit" className="btn primary" disabled={saving}>
          {saving ? 'Guardando…' : 'Guardar'}
        </button>
      </div>
    </form>
  );
};

export default ClienteForm;
